import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '@workbuddy/ui/v2/surface.engine/core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '@workbuddy/ui/v2/surface.engine/core/runtime/surfaces/surface.schema.slots';

// Full-page entity record. Sidebar summary (display-only) + tabbed body.
// Patch-on-blur autosave; default field mode is edit when permitted.
export const manageSurface = {
  id: SurfaceType.Manage,
  saveStrategy: 'patch',
  defaultFieldMode: 'edit',
  // Active tab in ?tab= for deep links + Clarity (no full page reload).
  viewStatePersistence: 'url',
  sectionLayout: { columns: 2, maxWidth: 1600, sectionBorder: false, columnDivider: true },
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.Manage],
} as const satisfies SurfaceTypeDefinition<SurfaceType.Manage>;
